module.exports = __webpack_public_path__ + "static/media/success_check.79fbab0f.svg";